import { render, staticRenderFns } from "./partSize.vue?vue&type=template&id=5cf9a4cc&scoped=true"
import script from "./partSize.vue?vue&type=script&lang=js"
export * from "./partSize.vue?vue&type=script&lang=js"
import style0 from "./partSize.vue?vue&type=style&index=0&id=5cf9a4cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf9a4cc",
  null
  
)

export default component.exports